import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'

export default class CompanyID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
